import isDoubleClick from './is-double-click';

const packstationToggleSelector = '.packstation-toggle';
const packstationWrapperSelector = '.packstation-wrapper';

/**
 * Initialize the packstation fields and jQuery events
 * @param {jQuery} $formElement - Form that includes the input fields
 * @param {jQuery} $countryList - Country select
 */
function init($formElement, $countryList) {
  const $form = $formElement;
  const $countrySelect = $countryList;
  const $packstationToggle = $form.find(packstationToggleSelector);

  /**
   * Shows or hides the packstation form fields and shows the invoice address form if available.
   * If packstationEnabled is true, the invoice address has to be entered
   * (distinct_invoice_address can't be unchecked)
   * @param {boolean} packstationEnabled - checkbox is checked or not
   */
  function updateFieldVisibility(packstationEnabled) {
    const invoiceAddressToggle = $form.find('.invoice-address-toggle');
    const invoiceAddressWrapper = $form.find('.invoice-address-wrapper');

    // show the packstation fields
    $form.find(packstationWrapperSelector).toggle(packstationEnabled);

    // show the invoice address form
    if (packstationEnabled) {
      invoiceAddressToggle
        .val(packstationEnabled)
        .prop('checked', true)
        .change()
        .parent('.checkbox-element')
        .addClass('checked');

      invoiceAddressWrapper.show();
    }
    // distinct invoice address has to be mandatory
    invoiceAddressToggle.prop('readonly', packstationEnabled);


    // toggle checkbox switch view (ios8)
    $packstationToggle
      .parent('.checkbox-element')
      .toggleClass('checked', packstationEnabled);

    // toggle street fields
    $form
      .find('input[name*="street"]')
      .not('.invoice-address-wrapper input[name*="street"]')
      .closest('.form-group')
      .toggle(!packstationEnabled);
  }

  /**
   * Shows the checkbox if the selected shipping country is germany
   * @param {string} countryId - Country Id.
   */
  function togglePackstationOption(countryId) {
    $packstationToggle
      .closest('.form-group')
      .toggle(countryId === 'DE');

    updateFieldVisibility($packstationToggle.prop('checked') && countryId === 'DE');
  }

  /**
   * Initializes the necessary listeners to country select and packstation checkbox
   */
  function initListeners() {
    togglePackstationOption($countrySelect.val());

    $countrySelect.change(function () {
      togglePackstationOption($(this).val());
    });

    $packstationToggle.click(function (e) {
      if (isDoubleClick(e)) {
        return false;
      }
      
      updateFieldVisibility($(this).prop('checked'));
    });

    $form.on('sgFramework.forms.validation.set', (e, errors) => {
      if (errors && Array.isArray(errors)) {
        errors.forEach((error) => {
          if (error.element.indexOf('post_number') !== -1 || error.element.indexOf('packstation_number') !== -1) {
            // if we have a validation error, we want to reset/clear the street fields
            $form
              .find('input[name*="street"]')
              .not('.invoice-address-wrapper input[name*="street"]')
              .val('');
          }
        });
      }
    });
  }

  initListeners();
}


export default {
  packstationToggleSelector,
  packstationWrapperSelector,
  init,
};



// WEBPACK FOOTER //
// ./Library/1.0/common/shopgate-dhl-packstation.js